import { GQLResponseError, GQLResponseServerError } from '@change-corgi/core/gql';
import type { UtilityContext } from '@change-corgi/core-react/utilityContext';
import type { LoginState } from '@change-corgi/middle-end-gql-schema';

import type { PhoneNumber } from '#src/app/shared/utils/phoneCollection';

import { ViewerPhoneNumber, type ViewerPhoneNumberQuery, type ViewerPhoneNumberQueryVariables } from './api.graphql';

export type PhoneNumberData = {
	phoneNumber: PhoneNumber;
	serverLoginState: LoginState;
};

export async function getViewerPhoneNumber(
	currentUserLoginState: string,
	{ gql: { fetch } }: UtilityContext,
): Promise<PhoneNumberData | undefined> {
	// return early if the current user is not authenticated
	if (currentUserLoginState !== 'AUTHENTICATED') return undefined;

	let data: ViewerPhoneNumberQuery;
	try {
		({ data } = await fetch<ViewerPhoneNumberQuery, ViewerPhoneNumberQueryVariables>({
			query: ViewerPhoneNumber,
			rejectOnError: true,
		}));
	} catch (error) {
		// viewer.loginState can resolve successfully even when viewer.user.phoneNumber errors out;
		// a missing phone number is non-critical, so we tolerate a GQL-level field error here and
		// let a transport/server failure (GQLResponseServerError) propagate as usual
		if (error instanceof GQLResponseError && !(error instanceof GQLResponseServerError)) {
			return undefined;
		}
		throw error;
	}

	const serverLoginState = data.viewer.loginState;

	// if the server's login state is not authenticated, then there will be no user
	if (serverLoginState !== 'AUTHENTICATED') return undefined;

	return { phoneNumber: data.viewer.user?.authOnlyData?.phoneNumber, serverLoginState };
}
